module.exports = __webpack_public_path__ + "media/images/app/how-it-works/hero-hiw-mobile-96499652b3376ce006063bc1f84a0071.webp";